import React from 'react';
import { Box, Center, Spinner, Text, VStack, Button, Icon } from '@chakra-ui/react';
import { FiAlertTriangle, FiInbox } from 'react-icons/fi';

export const LoadingState: React.FC<{ label?: string }> = ({ label = 'Loading…' }) => (
  <Center py={16}>
    <VStack spacing={3}>
      <Spinner color="brand.500" thickness="3px" size="lg" />
      <Text color="gray.500" fontSize="sm">
        {label}
      </Text>
    </VStack>
  </Center>
);

export const ErrorState: React.FC<{ message: string; onRetry?: () => void }> = ({ message, onRetry }) => (
  <Center py={16}>
    <VStack spacing={3} textAlign="center">
      <Icon as={FiAlertTriangle} boxSize={8} color="red.400" />
      <Text fontWeight="medium">Something went wrong</Text>
      <Text color="gray.500" fontSize="sm" maxW="md">
        {message}
      </Text>
      {onRetry && (
        <Button size="sm" variant="outline" onClick={onRetry}>
          Try again
        </Button>
      )}
    </VStack>
  </Center>
);

export const EmptyState: React.FC<{ title: string; hint?: string; action?: React.ReactNode }> = ({
  title,
  hint,
  action,
}) => (
  <Box py={16}>
    <VStack spacing={3} textAlign="center">
      <Icon as={FiInbox} boxSize={8} color="gray.400" />
      <Text fontWeight="medium">{title}</Text>
      {hint && (
        <Text color="gray.500" fontSize="sm" maxW="md">
          {hint}
        </Text>
      )}
      {action}
    </VStack>
  </Box>
);
